import styled from 'styled-components';

const DetailAddonInfoRightContainer = styled.div<React.CSSProperties>`
  height: 100%;
  width: 50%;
  float: left;
`;

export default DetailAddonInfoRightContainer;
